import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import './CategoryPageSeo.scss';

export default function CategoryPageSeo({ className, title, description }) {
    const rootClassnames = classnames('category-page__seo', className);

    return (
        <div className={rootClassnames}>
            <h2>{title}</h2>
            <p dangerouslySetInnerHTML={{ __html: description }} />
        </div>
    );
}

CategoryPageSeo.propTypes = {
    className: string,
    title: string,
    description: string,
};

CategoryPageSeo.defaultProps = {
    className: null,
    title: null,
    description: null,
};
